import React, {useEffect,useState,useCallback} from 'react';
import './Home.css'
import api from '../contexts/BaseUrl';
import LeftPanel from '../components/LeftPanel';
import Loading from '../components/Loading';

export default function Home(){

    const token = JSON.parse(localStorage.getItem('auth')).token;

    const [report,setReport] = useState([]);
    const [dateFrom,setDateFrom] = useState('');
    const [dateTo,setDateTo] = useState('');
    const [isLoading,setIsLoading] = useState(false);

    const dateFromObj = dateFrom ? new Date(dateFrom) : null;
    const dateToObj = dateTo ? new Date(dateTo) : null;

    var url;

    if(dateFromObj != null && dateToObj != null){
        url = `salesReports/filter-report?fromDate=${dateFrom}&toDate=${dateTo}`
    } else if(dateFromObj != null){
        url = `salesReports/filter-report?fromDate=${dateFrom}`
    }
    else{
        url = `salesReports/filter-report` ;
    }

    const fetchReport = useCallback(async () => {
        setIsLoading(true);
        await api.get(url,{
            headers: {Authorization: `Bearer ${token}`}
        }).then(response => {
            setReport(response.data);
            setIsLoading(false);
            
        }).catch(err =>{
            setIsLoading(false);
        })
    },[url, token])

    useEffect(() => {
        fetchReport();
     },[fetchReport])

    return(
        <div className='homePage'>
            <LeftPanel
                tabName = 'home'
            />
            <div id='rightPanel'>
                <div id='rightPanelContent'>
                    <div id='searchAddBox'>
                        <div className='dateBox'>
                            <input
                                type='date' 
                                className='dateInput'
                                onChange={e => setDateFrom(e.target.value)}
                                value={dateFrom}
                            />
                            <div id='to'>To</div>
                            <input
                                type='date' 
                                className='dateInput'
                                onChange={e => setDateTo(e.target.value)}
                                value={dateTo}
                            />
                        </div>
                    </div>
                    {isLoading ?
                    <Loading /> :
                    <>
                    <div id='filterBox'>
                        <div id='filterBoxData'>
                            <div id='titleHeader'>Small Pieces</div>
                            <div id='titleDetails'>{report.totalSmallPieces}</div>
                        </div>
                        <div id='filterBoxData'>
                            <div id='titleHeader'>Large Pieces</div>
                            <div id='titleDetails'>{report.totalLargePieces}</div>
                        </div>
                    </div>
                    <div id='filterBox'>
                        <div id='filterBoxData' style={{backgroundColor:'floralwhite'}}>
                            <div id='titleHeader'>Total Earnings</div>
                            <div id='titleDetails'>Tk {report.totalEarning}</div>
                        </div>
                        <div id='filterBoxData' style={{backgroundColor:'gainsboro'}}>
                            <div id='titleHeader'>Total Expenses</div>
                            <div id='titleDetails'>Tk {report.totalExpense}</div>
                        </div>
                    </div>
                    <div id='filterBox' style={{marginLeft:150}}>
                        <div id='filterBoxData' style={{backgroundColor:'darkcyan'}}>
                            <div id='titleHeader' style={{color:'floralwhite'}}>Cash on Hand</div>
                            <div id='titleDetails' style={{color:'white'}}>Tk {report.totalEarning - report.totalExpense}</div>
                        </div>
                        
                    </div>
                    </>}
                </div>
            </div>
        </div>
    )
}